define('MM/Components/ClientPortal/GatedModal',['jquery', 'eventManager'], function ($, eventManager) {

    function GatedModal(scope, signInSignUpButtonUrl, gatedModalDisplayedGoalId, gatedSignUpClickedGoalId, gatedSignInClickedGoalId, gatedModeQueryParamName) {
        if (!scope) throw Error('Cannot create GatedModal without scope element.');

        Object.defineProperties(this, {
            scope: { writable: !1, configurable: !0, enumerable: !0, value: scope },
            signInSignUpButtonUrl: { enumerable: !0, configurable: !0, writable: !1, value: signInSignUpButtonUrl },
            gatedModalDisplayedGoalId: { enumerable: !0, configurable: !0, writable: !1, value: gatedModalDisplayedGoalId },
            gatedSignUpClickedGoalId: { enumerable: !0, configurable: !0, writable: !1, value: gatedSignUpClickedGoalId },
            gatedSignInClickedGoalId: { enumerable: !0, configurable: !0, writable: !1, value: gatedSignInClickedGoalId },
            gatedModeQueryParamName: { enumerable: !0, configurable: !0, writable: !1, value: gatedModeQueryParamName }
        });

        var popup = $(this.scope.querySelector('.gated-modal'));
        popup.modal({
            backdrop: 'static',
            keyboard: false
        });

        document.body.classList.add("gated-content-modal-open");

        var btnSignUp = this.scope.querySelector(".gated-cta.gated-cta-signup");
        var btnSignIn = this.scope.querySelector(".gated-cta.gated-cta-signin");
        var btnClose = this.scope.querySelector(".modal-dialog button.close");

        btnSignUp.addEventListener('click', this.signInSignUpClickHandler.bind(this, this.gatedSignUpClickedGoalId, 'signup'));
        btnSignIn.addEventListener('click', this.signInSignUpClickHandler.bind(this, this.gatedSignInClickedGoalId, 'signin'));
        btnClose.addEventListener('click', this.closeModalClickHandler.bind(this));

        this.triggerGoal(this.gatedModalDisplayedGoalId);
        eventManager.trigger('gated_modal', 'displayed');
    }

    GatedModal.prototype.triggerGoal = function triggerGoal(goalId) {

        fetch('/scoreui/triggergoal/' + goalId, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }).catch(error => console.error(error));
    }

    GatedModal.prototype.closeModalClickHandler = function closeModalClickHandler(e) {
        eventManager.trigger('gated_modal', 'closed');
    }

    GatedModal.prototype.signInSignUpClickHandler = function signInSignUpClickHandler(mode, request, e) {
        e.preventDefault();

        this.triggerGoal(mode);
        eventManager.trigger('gated_modal', request);

        var uri = this.signInSignUpButtonUrl;

        var urlParams = new URLSearchParams(uri.toString());
        var identityReturnUrl = urlParams.get('ReturnUrl');
        var identityUrlParam = this._getParamsFromUri(identityReturnUrl);
        var identityUrl = identityUrlParam.get('ReturnUrl');

        var gatedParamKeyValue = identityUrl.includes('?')
            ? '&' + this.gatedModeQueryParamName + '=1'
            : '?' + this.gatedModeQueryParamName + '=1';

        var newIdentityUrl = encodeURIComponent(identityUrl + gatedParamKeyValue);
        var updatedReturnUrl = this._getUpdatedUri(identityReturnUrl, 'ReturnUrl', newIdentityUrl);

        urlParams.set('ReturnUrl', encodeURIComponent(updatedReturnUrl));
        urlParams.set('onSignUpRedirect', encodeURIComponent(identityUrl + gatedParamKeyValue));
        urlParams.set('gated', request);
        uri = decodeURIComponent(urlParams.toString());

        var formAuth = document.createElement("form");
        formAuth.method = "POST";
        formAuth.action = uri;
        document.body.appendChild(formAuth);

        formAuth.submit();
    }

    GatedModal.prototype._getParamsFromUri = function _getParamsFromUri(uri) {
        // Get everything after the `?`
        var paramString = uri.split('?')[1];
        // Return parameters
        return new URLSearchParams(paramString);
    }

    GatedModal.init = function init(args) {
        if (args.IsExperienceEditorEditing === !0) return null;

        return new GatedModal(
            args.scope,
            args.SignInSignUpButtonUrl,
            args.GatedModalDisplayedGoalId,
            args.GatedSignUpClickedGoalId,
            args.GatedSignInClickedGoalId,
            args.GatedModeQueryParamName
        );
    }

    GatedModal.prototype._getUpdatedUri = function _getUpdatedUri(uri, key, value) {
        // Get everything after the '?' and remove querystring after '&' as they are not needed
        var identityBaseString = uri.split('?')[0];
        var paramString = uri.split('?')[1];
        var newParamString = paramString.split('&')[0];

        // set parameter value for ReturnUrl
        var urlSearchParams = new URLSearchParams(newParamString);
        urlSearchParams.set(key, decodeURIComponent(value));
        uri = identityBaseString.concat('?', urlSearchParams.toString());

        return uri;
    }

    return GatedModal;
});
